// Generated by purs version 0.15.12
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_ObservableEvent from "../Fusion.Data.ObservableEvent/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var Generator = function (x) {
    return x;
};
var isFinalObservableEvent = {
    isFinal: function (v) {
        if (v instanceof Fusion_Data_ObservableEvent.OnNext) {
            return false;
        };
        if (v instanceof Fusion_Data_ObservableEvent.OnError) {
            return true;
        };
        if (v instanceof Fusion_Data_ObservableEvent.OnComplete) {
            return true;
        };
        throw new Error("Failed pattern match at Fusion.Generator (line 228, column 13 - line 231, column 23): " + [ v.constructor.name ]);
    }
};
var functorGenerator = function (dictFunctor) {
    var map = Data_Functor.map(dictFunctor);
    return {
        map: function (f) {
            return function (m) {
                return {
                    cancel: m.cancel,
                    next: map(f)(m.next)
                };
            };
        }
    };
};
var next = function (v) {
    return v.next;
};
var nextUntil = function (dictMonadRec) {
    var tailRecM = Control_Monad_Rec_Class.tailRecM(dictMonadRec);
    var mapFlipped = Data_Functor.mapFlipped((((dictMonadRec.Monad0()).Bind1()).Apply0()).Functor0());
    return function (checkFn) {
        return function (gen) {
            return Data_Function.flip(tailRecM)(Data_Unit.unit)(function (v) {
                return mapFlipped(next(gen))(function (v1) {
                    var $126 = checkFn(v1);
                    if ($126) {
                        return new Control_Monad_Rec_Class.Done(v1);
                    };
                    return new Control_Monad_Rec_Class.Loop(Data_Unit.unit);
                });
            });
        };
    };
};
var nextUntilComplete = function (dictMonadRec) {
    var tailRecM = Control_Monad_Rec_Class.tailRecM(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictMonadThrow) {
        var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
        return function (gen) {
            return Data_Function.flip(tailRecM)(Data_Unit.unit)(function (v) {
                return bind(next(gen))(function (v1) {
                    if (v1 instanceof Fusion_Data_ObservableEvent.OnComplete) {
                        return pure(new Control_Monad_Rec_Class.Done(Data_Unit.unit));
                    };
                    if (v1 instanceof Fusion_Data_ObservableEvent.OnError) {
                        return throwError(v1.value0);
                    };
                    if (v1 instanceof Fusion_Data_ObservableEvent.OnNext) {
                        return pure(new Control_Monad_Rec_Class.Loop(Data_Unit.unit));
                    };
                    throw new Error("Failed pattern match at Fusion.Generator (line 191, column 16 - line 194, column 33): " + [ v1.constructor.name ]);
                });
            });
        };
    };
};
var nextUntilJust = function (dictMonadRec) {
    var tailRecM = Control_Monad_Rec_Class.tailRecM(dictMonadRec);
    var mapFlipped = Data_Functor.mapFlipped((((dictMonadRec.Monad0()).Bind1()).Apply0()).Functor0());
    return function (checkFn) {
        return function (gen) {
            return Data_Function.flip(tailRecM)(Data_Unit.unit)(function (v) {
                return mapFlipped(next(gen))(function (v1) {
                    var v2 = checkFn(v1);
                    if (v2 instanceof Data_Maybe.Just) {
                        return new Control_Monad_Rec_Class.Done(v2.value0);
                    };
                    if (v2 instanceof Data_Maybe.Nothing) {
                        return new Control_Monad_Rec_Class.Loop(Data_Unit.unit);
                    };
                    throw new Error("Failed pattern match at Fusion.Generator (line 212, column 22 - line 214, column 25): " + [ v2.constructor.name ]);
                });
            });
        };
    };
};
var reEmitAccum = function (dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var discard1 = discard(Bind1);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    var tailRecM = Control_Monad_Rec_Class.tailRecM(dictMonadRec);
    return function (dictMonadThrow) {
        var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
        return function (initState) {
            return function (nextState) {
                return function (gen) {
                    return function (emit) {
                        var go = function (state) {
                            return bind(next(gen))(function (val) {
                                if (val instanceof Fusion_Data_ObservableEvent.OnNext) {
                                    return discard1(emit(val.value0))(function () {
                                        return pure(new Control_Monad_Rec_Class.Loop(nextState(state)(val.value0)));
                                    });
                                };
                                if (val instanceof Fusion_Data_ObservableEvent.OnError) {
                                    return throwError(val.value0);
                                };
                                if (val instanceof Fusion_Data_ObservableEvent.OnComplete) {
                                    return pure(new Control_Monad_Rec_Class.Done(state));
                                };
                                throw new Error("Failed pattern match at Fusion.Generator (line 108, column 5 - line 115, column 26): " + [ val.constructor.name ]);
                            });
                        };
                        return tailRecM(go)(initState);
                    };
                };
            };
        };
    };
};
var reEmit = function (dictMonadRec) {
    var reEmitAccum1 = reEmitAccum(dictMonadRec);
    return function (dictMonadThrow) {
        return reEmitAccum1(dictMonadThrow)(Data_Unit.unit)(function (v) {
            return function (v1) {
                return Data_Unit.unit;
            };
        });
    };
};
var waitForNext = function (dictManageAVar) {
    var Monad0 = dictManageAVar.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var empty = WE_Class_AVar.empty(dictManageAVar);
    var put = WE_Class_AVar.put(dictManageAVar);
    var discard1 = discard(Bind1);
    var tryRead = WE_Class_AVar.tryRead(dictManageAVar);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictMonadKill) {
        var fork = Control_Monad_Fork_Class.fork(dictMonadKill.MonadFork0());
        return function (dictMonadTime) {
            var delay = WE_Class_Time.delay(dictMonadTime);
            return function (wait) {
                return function (gen) {
                    return bind(empty)(function (av) {
                        return bind(fork(bind(next(gen))(function (val) {
                            return put(val)(av);
                        })))(function () {
                            return discard1(delay(wait))(function () {
                                return bind(tryRead(av))(function (v1) {
                                    return pure(v1);
                                });
                            });
                        });
                    });
                };
            };
        };
    };
};
var mapNat = function (f) {
    return function (v) {
        return {
            next: f(v.next),
            cancel: f(v.cancel)
        };
    };
};
var mapGenM = function (f) {
    return function (v) {
        return {
            next: f(v.next),
            cancel: v.cancel
        };
    };
};
var isFinal = function (dict) {
    return dict.isFinal;
};
var isFinalArray = function (dictIsFinal) {
    return {
        isFinal: (function () {
            var $150 = Data_Array.find(isFinal(dictIsFinal));
            return function ($151) {
                return Data_Maybe.isJust($150($151));
            };
        })()
    };
};
var isFinalEither = function (dictIsFinal) {
    var isFinal1 = isFinal(dictIsFinal);
    return {
        isFinal: function (v) {
            if (v instanceof Data_Either.Right) {
                return isFinal1(v.value0);
            };
            if (v instanceof Data_Either.Left) {
                return true;
            };
            throw new Error("Failed pattern match at Fusion.Generator (line 234, column 13 - line 236, column 19): " + [ v.constructor.name ]);
        }
    };
};
var isFinalNonEmptyArray = function (dictIsFinal) {
    return {
        isFinal: (function () {
            var $152 = Data_Array_NonEmpty.find(isFinal(dictIsFinal));
            return function ($153) {
                return Data_Maybe.isJust($152($153));
            };
        })()
    };
};
var collectObservable = function (dictMonad) {
    var bind = Control_Bind.bind(dictMonad.Bind1());
    var pure = Control_Applicative.pure(dictMonad.Applicative0());
    return function (gen) {
        return bind(next(gen))(function (v) {
            if (v instanceof Fusion_Data_ObservableEvent.OnComplete) {
                return pure([  ]);
            };
            if (v instanceof Fusion_Data_ObservableEvent.OnError) {
                return pure([ new Data_Either.Left(v.value0) ]);
            };
            if (v instanceof Fusion_Data_ObservableEvent.OnNext) {
                return bind(collectObservable(dictMonad)(gen))(function (rest) {
                    return pure(Data_Array.cons(new Data_Either.Right(v.value0))(rest));
                });
            };
            throw new Error("Failed pattern match at Fusion.Generator (line 203, column 3 - line 208, column 39): " + [ v.constructor.name ]);
        });
    };
};
var cancellationExceptionFSE = /* #__PURE__ */ (function () {
    return Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl55.value)("CancellationException");
})();
var kill_ = function (dictMonadKill) {
    return Control_Monad_Fork_Class.kill(dictMonadKill)(cancellationExceptionFSE);
};
var form2toForm1 = function (dictManageAVar) {
    var Monad0 = dictManageAVar.Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var empty = WE_Class_AVar.empty(dictManageAVar);
    var put = WE_Class_AVar.put(dictManageAVar);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    var take = WE_Class_AVar.take(dictManageAVar);
    return function (dictMonadFork) {
        var fork = Control_Monad_Fork_Class.fork(dictMonadFork);
        return function (dictMonadKill) {
            var kill_1 = kill_(dictMonadKill);
            return function (dictMonadError) {
                var catchError = Control_Monad_Error_Class.catchError(dictMonadError);
                var throwError = Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0());
                return function (mkGenerator) {
                    return bind(empty)(function (av) {
                        return bind(fork(catchError(mkGenerator(function (val) {
                            return put(new Data_Either.Right(val))(av);
                        }))(function (err) {
                            return put(new Data_Either.Left(err))(av);
                        })))(function (fiber) {
                            return pure({
                                next: bind(take(av))(function (result) {
                                    if (result instanceof Data_Either.Left) {
                                        return throwError(result.value0);
                                    };
                                    if (result instanceof Data_Either.Right) {
                                        return pure(result.value0);
                                    };
                                    throw new Error("Failed pattern match at Fusion.Generator (line 160, column 11 - line 162, column 34): " + [ result.constructor.name ]);
                                }),
                                cancel: kill_1(fiber)
                            });
                        });
                    });
                };
            };
        };
    };
};
var cancellationException = /* #__PURE__ */ Effect_Exception.error("CancellationException");
var cancel = function (v) {
    return v.cancel;
};
var reEmitF = function (dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var Bind1 = dictMonad.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var discard1 = discard(Bind1);
    var when = Control_Applicative.when(Applicative0);
    return function (dictIsFinal) {
        var isFinal1 = isFinal(dictIsFinal);
        return function (dictMonadBracket) {
            var bracket = Control_Monad_Fork_Class.bracket(dictMonadBracket);
            return function (gen) {
                return function (emit) {
                    return bracket(pure(gen))(function (v) {
                        return function (v1) {
                            return cancel(gen);
                        };
                    })(function (gen1) {
                        return bind(next(gen1))(function (v) {
                            return discard1(emit(v))(function () {
                                return when(!isFinal1(v))(reEmitF(dictMonad)(dictIsFinal)(dictMonadBracket)(gen1)(emit));
                            });
                        });
                    });
                };
            };
        };
    };
};
export {
    Generator,
    cancel,
    cancellationException,
    cancellationExceptionFSE,
    collectObservable,
    form2toForm1,
    isFinal,
    kill_,
    mapGenM,
    mapNat,
    next,
    nextUntil,
    nextUntilComplete,
    nextUntilJust,
    reEmit,
    reEmitAccum,
    reEmitF,
    waitForNext,
    functorGenerator,
    isFinalObservableEvent,
    isFinalEither,
    isFinalArray,
    isFinalNonEmptyArray
};
